import { reservationConstants } from '../constants';
import { hydrateReservation } from '../helpers';

export function reservations(state = {}, action) {
  switch (action.type) {
    case reservationConstants.GETRESERVATIONS_SUCCESS:
      return {
        items: action.reservations.map(res => hydrateReservation(res))
      };
    case reservationConstants.GETRESERVATIONS_FAILURE:
      return {
        error: action.error
      };
    case reservationConstants.DELETERESERVATIONS_SUCCESS:
      return {
        items: state.items.filter(row => row.id !== action.id)
      };
    case reservationConstants.EDITRESERVATIONS_SETUP:
      return {
        ...state,
        edit: state.items ? state.items.find(item => item.id === +action.id) : null
      };
    case reservationConstants.EDITRESERVATIONS_SET:
      return {
        ...state,
        edit: hydrateReservation(action.res)
      }
    case reservationConstants.ADDRESERVATIONS_SETUP:
      return {
        ...state,
        add: hydrateReservation({ ...action.res, ...{ clients: [], nbCreneau: 1, canEdit: true } })
      };
    case reservationConstants.ADDRESERVATIONS_SET:
      return {
        ...state,
        add: hydrateReservation(action.res)
      }
    case reservationConstants.PATCHRESERVATIONS_SUCCESS:
      return {
        items: state.items.map(item => item.id === action.oldId ? hydrateReservation(action.res) : item)
      };
    case reservationConstants.POSTRESERVATIONS_SUCCESS:
      return {
        items: [hydrateReservation(action.res), ...state.items]
      };
    default:
      return state
  }
}